/* eslint-disable */
import * as log from 'loglevel';
import AxiosAPI from '../services/AxiosAPI';
import successIcon from '../assets/images/success.svg';
import Session from './session'; 
import User from '../services/User';
import axios from 'axios';
import amountFilter from './amountFilter';
import taxFilter from './taxFilter';

const UtilityMixins = {
  data() {
    return {
      irClickId: null,  // Impact radius click id
      country: 'US', //SET default country to US
      supportedCountries : ['US','GB','CA','AU','PR','AS','GU','MP','VI'],
      sessionID: '',
      screenSize: {
        xl: 1440,
        lg: 1024,
        md: 768,
        sm: 576,
        xs: 375,
      },
      currentScreenWidth: window.innerWidth,
    };
  },
  created() {
  },
  beforeMount() {
    // this.setUserCountry();
    this.setImpactClickId();
    this.sessionID = Session.getSessionId();
  },
  computed: {
    isInternationalUser() {
      const { country } = this.$store.getters;

      return !this.supportedCountries.includes(country);
    },
    pricing() {
      const { pricing } = this.$store.getters;
      const currencySymbol = pricing.currency === 'GBP' ? '£' : '$'
      return `${currencySymbol}${pricing.price}`;
    },
    isMarketingPage() {
      const marketingPages = ['/', '/premium', '/international', '/shows'];
      return marketingPages.includes(this.$route.path);
    },
    localPricing() {
      return this.$store.getters.pricing;
    },
    promoMeta() {
      const promoData = this.$store.getters.promoData;
      promoData.formattedTrialPeriod = promoData.trialPeriod > 1 ? `${promoData.trialPeriod} months` : `${promoData.trialPeriod} month`;
      return promoData;
    },
    formattedLocalPricingWithTax() {
      const { pricing } = this.$store.getters;

      if (pricing && pricing.price && pricing.currency) {
        return `${amountFilter(pricing.price, pricing.currency)} ${taxFilter(pricing.price, pricing.currency)}`
      }

      return '';
    },
    detectMobileOs() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
        return 'android';
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'ios';
      }

      return 'unknown';
    },
    isSafariMobile() {
      return document.querySelector('#app').classList.contains('is-safari') && this.currentScreenWidth <= this.screenSize.md;
    }
  },
  methods: {
    setMetaInformation(title, metaDesc) {
      if (!title) {
        document.title = 'Luminary Web';

        const metaDescription = document.querySelector('.meta-description');
        if (metaDescription) {
          metaDescription.content = "Luminary is a podcast streaming platform that gives you access to 500k+ shows, when and where you want. Sign up today and be the first to try @luminary!";
        }
      } else {
        document.title = title;
        const metaTitle = document.querySelectorAll('.meta-title');
        if (metaTitle) {
          metaTitle.forEach(item => {
            item.content = title;
          })
        }
        const metaDescription = document.querySelectorAll('.meta-description');
        if (metaDescription) {
          metaDescription.forEach(item => {
            item.content = this.$options.filters.truncate(metaDesc, 160);
          })
        }
      }
    },
    isBrowserSafari() {
      // Bieng set in App.vue
      return document.querySelector('#app').classList.contains('is-safari');
    },

    isRestrictedCountry() {
      return !this.supportedCountries.includes(this.country);
    },

    setImpactClickId() {
      if (this.$route && (this.$route.query.IRCLICKID || this.$route.query.irclickid)) {
        // Store it in the local variable
        let key = this.$route.query.IRCLICKID ? 'IRCLICKID' : 'irclickid';
        this.irClickId = this.$route.query[key];
        // Store it for future references
        this.$store.dispatch('setIrClickId', this.irClickId);

        /*
        const query = Object.assign({}, this.$route.query);
        delete query[key];
        this.$router.replace({ query });
        */
      }
    },

    getImpactClickId() {
      return this.$store.getters.irClickId;
    },

    setUserCountry() {
      var urlParams = new URLSearchParams(window.location.search);
      const countryCode = urlParams.get('country');
      if (this.$route && this.$route.query.country) {
        // Store it in the local variable
        this.country = this.$route.query.country;
        // Store it for future references
        this.$store.dispatch('setUserCountry', this.country);
        // Remove country code from query param
        const query = Object.assign({}, this.$route.query);
        delete query.country;
        this.$router.replace({ query });
      } else if (countryCode) {
        this.country = countryCode;
        this.$store.dispatch('setUserCountry', this.country);
      }
      else this.country = (this.$store && this.$store.getters && this.$store.getters.country) || 'US';
    },

    getUserCountry() {
      return this.$store.getters.country;
    },

    showSuccessMsg(message) {
      const div = `
        <div class="message">
          <img src=${successIcon} />
          <p>
            ${message}
          </p>
        </div>
      `;

      const useOffset = document.querySelector('body').classList.contains('audio-player-visible');

      this.$notify({
        title: '',
        message: div,
        position: 'bottom-left',
        customClass: 'success',
        dangerouslyUseHTMLString: true,
        offset: useOffset ? 75 : 0,
      });
    },

    showErrorMsg(message) {
      const useOffset = document.querySelector('body').classList.contains('audio-player-visible');

      this.$notify({
        title: '',
        message,
        position: 'bottom-left',
        customClass: 'error',
        offset: useOffset ? 75 : 0,
      });
    },

    confirmDelete(_message) {
      const message = _message || 'This will permanently delete the item. Continue?';
      return this.$confirm(message, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true,
      });
    },

    playPodcast(podcast, progress = null) {
      window.eventBus.$emit('play-podcast', {
        podcast: podcast.podcast || podcast,
        progress,
      });
    },

    progressiveImageError(error) {
      log.error(error);
    },

    showLoginDialog() {
    },

    setMediaPlaybackNotification(_title, _artist, imgUrl) {
      // Only works for chrome android
      if ('mediaSession' in navigator) {
        navigator.mediaSession.metadata = new MediaMetadata({
          title: _title,
          artist: _artist,
          album: '',
          artwork: [
            { src: imgUrl },
          ],
        });
        navigator.mediaSession.setActionHandler('play', () => { this.$store.dispatch('play'); });
        navigator.mediaSession.setActionHandler('pause', () => { this.$store.dispatch('pause'); });
      }
    },

    isInObject(obj, key) {
      return obj && obj.hasOwnProperty(obj, key);
    },

    scrollToElement(element) {
      if (!window || !document.querySelector(element)) return;
      document.querySelector(element).scrollIntoView({
        behavior: 'smooth',
      });
    }, 
    
    isNullOrWhiteSpace(str) {
      return !str || !str.trim().length;
    },

    async loadMediaInPlayer(media_url, is_exclusive) {
      if (!is_exclusive) {
        this.setAudioSrc(media_url);
        return;
      }

      const userProvider = new User();
      const token = await userProvider.getUserToken();
      //TODO: Encode token
      const axiosAPI = new AxiosAPI();
        axios.get(media_url+"?token="+token,  {withCredentials: true} ).then(resp => {
          this.setAudioSrc(media_url);
        })
        .catch((error) => {
          window.$store.dispatch('setStatus', 'failed');
        });
    },

    setAudioSrc(media_url) {
      const player = document.getElementById('audio');
      player.setAttribute('src', media_url);
      player.load();
      window.$store.dispatch('setStatus', 'loading');
    },
    
    isDeviceTouch() {
      return document.getElementsByTagName('html')[0].classList.contains('isTouch');
    },

    srcSet(type, filePathArray) {
      if (type === 'srcset') {
        return filePathArray.map((path, idx) => {
          return `${path} ${idx + 1}x`;
        }).join(', ');
      }
      return filePathArray[0];
    },

    fetchCurrencySymbol(currency) {
      let currencySymbol = '$';
      switch (currency) {
        case 'USD': {
          currencySymbol = '$';
          break;
        }
        case 'CAD': {
          currencySymbol = 'CAD$';
          break;
        }
        case 'GBP': {
          currencySymbol = '£';
          break;
        }
        case 'AUD': {
          currencySymbol = 'AU$';
          break;
        }
        default: {
          currencySymbol = '$';
        }
      }
      return currencySymbol;
    },

    disableVerticalScroll() {
      document.body.classList.add('vertical-scroll-disable');
      // document.body.style.overflowY = 'hidden';
    },

    enableVerticalScroll() {
      document.body.classList.remove('vertical-scroll-disable');
      // document.body.style.overflowY = 'auto';
    },
    mapTargetBlankToAnchorTags(cssSelector) {
      const aTags = document.querySelectorAll(cssSelector);
      for (let i = 0; i < aTags.length; i++) {
        aTags[i].setAttribute('target', '_blank');
      }
    },
  },
};

export default UtilityMixins;



// WEBPACK FOOTER //
// ./app/src/shared/mixins.js